import { $nickname } from '@/entities/profile-entity';
import { SenderDisabledBanner } from '@/pages/sender/sender-disabled-banner';
import { useUnit } from 'effector-react';
import AuthErrorMessage from './auth-error-message';
import AuthHero from './auth-hero';
import AuthLayout from './auth-layout';
import AuthPinDots from './auth-pin-dots';
import AuthPinPad from './auth-pin-pad';
import AuthSuccessOverlay from './auth-success-overlay';
import { usePinAuth } from './use-pin-auth';

type AuthPageProps = {
	redirectTo?: string;
};

export default function AuthPage({ redirectTo }: AuthPageProps) {
	const [nickname] = useUnit([$nickname]);
	const { pin, isSubmitting, error, senderDisabled, success, shakeKey, appendDigit, deleteDigit } = usePinAuth(
		nickname,
		{
			redirectTo,
		},
	);

	if (!nickname) {
		return null;
	}

	if (senderDisabled) {
		return (
			<AuthLayout>
				<div className='flex w-full flex-1 items-center justify-center p-4'>
					<div className='w-full max-w-sm'>
						<SenderDisabledBanner reason='disabled' />
					</div>
				</div>
			</AuthLayout>
		);
	}

	return (
		<>
			<AuthLayout>
				<AuthHero nickname={nickname} success={success} />
				<div className='flex w-full flex-col items-center gap-4'>
					<AuthPinDots pin={pin} error={error} shakeKey={shakeKey} isSubmitting={isSubmitting} />
					<AuthErrorMessage message={error} />
					<AuthPinPad
						disabled={isSubmitting || success}
						isSubmitting={isSubmitting}
						onDigit={appendDigit}
						onDelete={deleteDigit}
					/>
				</div>
				<AuthSuccessOverlay show={success} />
			</AuthLayout>
		</>
	);
}
